import { render } from "./App.vue?vue&type=template&id=4edd84d0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4edd84d0&lang=less"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__